// extracted by mini-css-extract-plugin
export default {"searchBody":"Body_searchBody__rFqNz","searchBodyWrapper":"Body_searchBodyWrapper__BeLAx"};